import { render, staticRenderFns } from "./CCAction.vue?vue&type=template&id=4b3758a4&"
import script from "./CCAction.vue?vue&type=script&lang=ts&"
export * from "./CCAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports